export default "__VITE_ASSET__DXX6dVbw__"